import { useControls } from "leva";
import { ModelProps } from "./Model";

export function Lid({ nodes, textures }: ModelProps) {
  const { show, color, normalIntensity, roughnessIntensity } = useControls(
    "Lid",
    {
      show: true,
      color: {
        value: "#4e4e4e",
      },
      normalIntensity: {
        value: 0.4,
        min: 0,
        max: 5,
        step: 0.1,
      },
      roughnessIntensity: {
        value: 1.5,
        min: 0,
        max: 5,
        step: 0.1,
      },
    },
    { collapsed: true }
  );

  if (!show) return;
  return (
    <mesh name="Lid" castShadow receiveShadow geometry={nodes.Lid.geometry}>
      <meshStandardMaterial
        color={color}
        normalMap={textures.normals}
        roughnessMap={textures.rough}
        normalScale={[normalIntensity, normalIntensity]}
        roughness={roughnessIntensity}
      />
    </mesh>
  );
}
